import React, {useContext} from "react";
import {FormattedMessage} from "react-intl";

// @mui/material components
import {
    Box,
    MenuItem,
    FormControl,
    Select
} from "@mui/material";

// @mui/icons-material components
import {ExpandMore} from "@mui/icons-material";

// context
import {CancellationReasonContext} from "contexts/CancellationReasonContext";

// utils
import {ReturnResolutions} from "utils/returnResolutions";

// style
import {blueColor} from "assets/jss/main";
import {makeStyles} from "@mui/styles";

const useStyles = makeStyles(theme => ({
    label: {
        margin: '10px 0 8px',
    },
    select: {
        borderRadius: '10px',
        padding: '15px',
        background: blueColor,
        color: 'white',
        fontSize: '1rem',
        marginBottom: '10px',
        '& .MuiSelect-icon': {
            color: 'white',
            top: '14px',
            position: 'absolute',
            marginRight: '0.5em',
        }
    },
    form: {
        '& .MuiInput-underline::after': {
            borderBottom: 'none',
        },
        '& .MuiInput-underline::before': {
            borderBottom: 'none',
        },
        '& .MuiInput-underline:hover:not(.Mui-disabled)::before': {
            borderBottom: 'none',
        },
    },
    placeholder: {
        display: 'none',
    },
}));

// Mode of a return opened from the OMS (by post / in store), offered only to organizations
// with the returnResolutionChoice flag. Sent along with the reason to the cancellation-reason endpoint.
export default function ReturnResolutionSelect() {
    const classes = useStyles();

    const {
        returnResolution,
        setReturnResolution
    } = useContext(CancellationReasonContext);

    return (
        <Box sx={{ minWidth: 120 }}>
            <p className={classes.label}>
                <b><FormattedMessage id={"picking.order.show.cancellationReason.dialog.returnResolution.label"} /></b>
            </p>
            <FormControl variant="standard" fullWidth className={classes.form}>
                <Select
                    variant="standard"
                    value={returnResolution ?? ""}
                    displayEmpty={true}
                    onChange={(event) => setReturnResolution(event.target.value)}
                    className={classes.select}
                    IconComponent={ExpandMore}
                >
                    <MenuItem value="" disabled className={classes.placeholder}>
                        <FormattedMessage id={"picking.order.show.cancellationReason.dialog.returnResolution.placeholder"} />
                    </MenuItem>
                    {Object.values(ReturnResolutions).map((resolution) => (
                        <MenuItem value={resolution} key={resolution}>
                            <FormattedMessage id={`picking.order.show.cancellationReason.dialog.returnResolution.${resolution}`} />
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Box>
    );
}
